import { Paper } from "@mui/material";
import { ReactNode } from "react";

interface IFilterWrapperProps {
    children: ReactNode
}

const FilterWrapper = (props: IFilterWrapperProps) => {

    return (
        <Paper elevation={1} sx={{ p: 2 }}>
            {props.children}
        </Paper>
    );
};

export default FilterWrapper;